'use strict';

module.exports = !('0' in Object('a'));


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/NO_KEYS_IN_STRING_OBJECTS.js
// module id = 1367
// module chunks = 0